import axios from "axios";

export const CARGA_TOKEN_KEY = "carga_token";
const cargaApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/carga`, withCredentials: false });
cargaApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(CARGA_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
cargaApi.interceptors.response.use((r) => r, (error) => {
  if (error.response?.status === 401 && localStorage.getItem(CARGA_TOKEN_KEY) && !(error.config?.url || "").includes("/auth/login")) {
    localStorage.removeItem(CARGA_TOKEN_KEY);
    window.dispatchEvent(new Event("carga:logout"));
  }
  return Promise.reject(error);
});
export const cargaErr = (e, fallback = "Algo salió mal") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};
export const cop = (n) => `$${Math.round(Number(n || 0)).toLocaleString("es-CO")}`;
export default cargaApi;
